import PropTypes from "prop-types";
// @mui/material components
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import classNames from "classnames";


const styles = (theme) => ({
  grid: {
    margin: "0 -15px !important",
    width: "unset"
  }
});


export default function GridContainer(props) {
  const theme = useTheme()
  const classes = styles(theme);
  const { children, ...rest } = props;
  return (
    <Grid container {...rest} sx = {{ 
          margin: "0 -15px !important",
          width: "unset"
        }}>
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string

};
